<template>
    <app-layout v-if="isPageReady">
        <common-content-spacer height="medium">
            <common-content-spacer height="small">
                <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>

                <common-page-header :heading="pageTitle"></common-page-header>
            </common-content-spacer>

            <common-page-plain>
                <common-content-spacer height="large">
                    <request-appointment-at-join-invite
                        v-if="!isEmailSent"
                        :joinInvite="joinInvite"
                        @emailSent="emailSent"
                    ></request-appointment-at-join-invite>

                    <div v-else class="send-successfuly">
                        <img :src="successIcon" />
                        <p>{{ $t('pages.network.request_appointment_at_join_invite.request_sent') }}</p>
                    </div>
                </common-content-spacer>
            </common-page-plain>
        </common-content-spacer>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import RequestAppointmentAtJoinInvite from '../../components/page-elements/network/RequestAppointmentAtJoinInvite'
    import UsersAPI from '../../api/UsersAPI'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin, PageWithDataMixin],
        components: {
            AppLayout,
            RequestAppointmentAtJoinInvite,
        },
        data() {
            return {
                isEmailSent: false,
                joinInvite: null,
            }
        },
        loadData(self) {
            return {
                joinInvite: UsersAPI.getMyJoinInviteById(self.$auth.getActiveMember().id, self.$route.params.id),
            }
        },
        computed: {
            pageTitle() {
                return this.$t('pages.network.request_appointment_at_join_invite.titles.request_appointment_at_invite', {
                    user: ` ${this.joinInvite ? this.joinInvite.toEmail.split('@')[0] : ''}`,
                })
            },
            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.network.request_appointment_at_join_invite.breadcrumbs.network'),
                        route: { name: 'network.connections' },
                    },
                    {
                        label: this.$t(
                            'pages.network.request_appointment_at_join_invite.breadcrumbs.request_appointment_at_invite',
                        ),
                    },
                ]
            },
            successIcon() {
                return require('./../../../src/images/sucess-icon.svg').default
            },
        },
        methods: {
            emailSent() {
                this.isEmailSent = true
            },
        },
    }
</script>

<style scoped>
    .send-successfuly {
        margin-top: 50px;
        margin-bottom: 100px;
        text-align: center;
    }

    .send-successfuly img {
        width: 50px;
        margin-bottom: 20px;
    }

    .send-successfuly p {
        font-size: 26px;
        font-weight: 600;
    }
</style>
